import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import logoCabanaWhite from '../images/logonext-white.svg';
import logoCabanaBlack from '../images/logonext-dark.svg';
import chatDemo from '/images/chat-demo.svg';

const StyledImage = styled('img')(({ theme }) => ({
  borderRadius: 12,
  filter: theme.palette.mode === 'light'
    ? 'drop-shadow(-8px -8px 12px rgba(0, 0, 0, 0.16))'
    : 'none',
  objectFit: 'contain',
}));

const animacaoPulsar = `
    @keyframes pulsar {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
      100% {
        transform: scale(1);
      }
    }
  `;

export default function Hero() {
  const navigate = useNavigate();
  return (
    <Box
      id="hero"
      // ALTERAÇÃO: Trocamos os valores HSL de azul para verde.
      sx={(theme) => ({
        width: '100%',
        backgroundRepeat: 'no-repeat',
        // Modo claro: um verde bem claro (equivalente a brand[100])
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsla(116, 81%, 71%, 1.00), transparent)',
        ...theme.applyStyles('dark', {
          // Modo escuro: um verde escuro e saturado (equivalente a brand[800])
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsla(122, 25%, 27%, 1.00), transparent)',
        }),
      })}
    >
      <Container
        sx={{
          pt: { xs: 14, sm: 10 },
          pb: { xs: 8, sm: 12 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: 5, sm: 20 },
            alignItems: 'center',
            mt: { xs: 5, sm: 10 },
          }}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              width: { xs: '100%', sm: '70%' },
            }}
          >
            <style>{animacaoPulsar}</style>
            <Box
              sx={(theme) => ({
                animation: 'pulsar 3s ease-in-out infinite',
                width: { xs: '300px', sm: 500, md: 500 },
                backgroundImage: `url(${logoCabanaBlack})`,
                ...theme.applyStyles('dark', {
                  backgroundImage: `url(${logoCabanaWhite})`,
                }),
                backgroundSize: { xs: '300px 150px', sm: '500px 200px', md: '500px 200px' },
                backgroundRepeat: 'no-repeat',
                height: { xs: 150, sm: 200, md: 200 },
              })}
            >
            </Box>
            <Typography
              sx={{
                textAlign: 'center',
                color: 'text.secondary',
                width: { sm: '100%', md: '80%' },
                fontSize: '1.5rem',
              }}
            >
              Coloque a inteligência artificial para atender seus clientes no seu WhatsApp.
              Atendimento automático 24/7, respostas instantâneas e mais vendas
              para seu negócio.
            </Typography>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={1}
              useFlexGap
              sx={{ pt: 2, width: { xs: '100%', sm: '50%' } }}
            >
              <Button
                variant="contained"
                // color="primary"
                size="large"
                href="http://wa.me/5522981007438/?text=Estou vindo do site e quero uma demonstração."
                target='_blank'
                fullWidth
                sx={(theme) => ({
                  py: 1.5,
                  fontSize: '1.1rem',
                  background: theme.palette.mode === 'dark' ? '#fffcf2 !important' : '#0E0E0E !important',
                  color: theme.palette.mode === 'dark' ? '#0E0E0E !important' : '#fffcf2 !important',
                })}
              >
                Veja uma Demonstração
              </Button>
            </Stack>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: 'center' }}
            >
              Atendimento 24h • Escala de vendas • Garantia de 7 dias
            </Typography>
          </Stack>
          <Stack sx={{ display: 'flex', alignItems: 'center' }}>
            <StyledImage
              src={chatDemo}
              alt="Demonstração do Nextalk no WhatsApp"
              sx={{
                width: { xs: '100%', sm: '70%', md: 420 },
                mr: { xs: 0, md: 5 },
              }}
            />
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                textAlign: 'center',
                fontStyle: 'italic',
                fontSize: '0.7rem',
                mr: { xs: 0, md: 5 },
              }}
            >
              Exemplo de um atendimento feito por um assistente virtual.
            </Typography>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}